export function ActionsIcon() {
  return (
    <span
      style={{
        transform: "translateX(6px) translateY(-2px) rotate(90deg)",
        fontSize: 16,
        fontWeight: 600,
      }}
      data-testid="actions-icon"
    >
      …
    </span>
  );
}
